
import { defineComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup() {
    const route = useRoute()
    onMounted(() => {
      if(route.hash) {
        const targetContent = document.querySelector(route.hash) as HTMLElement
        scrollTo(0, targetContent.offsetTop)
      }
    })
  },
})
